<script setup>
import { useIns } from 'src/utils/v2_helper/common';

const app = useIns();
</script>

<template>
  <div class="cancel">
    <div class="cancel-top">
      <div class="cancel-top_core">
        <img class="icon" src="../../../assets/images/result/Upset.png" />
        <div class="msg" bold>{{ $t('fullDinein.cancelMsg') }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cancel {
  background-repeat: no-repeat;
  background-position: center 0;
  background-image: url('~src/assets/images/result/canceledBg.png');
  background-size: cover;
  &-top {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 370px;
    &_core {
      text-align: center;
      margin: 0 30px;
      div + div {
        line-height: 1.2;
        margin-top: 10px;
      }
    }
    .msg {
      font-size: 24px;
      text-align: center;
      color: $negative;
    }
  }
}
</style>
